// ./src/config/auth.ts
export default {
  rebox: {
    api: {
      authentication: {
        token: {
          bearer: 'dba7a97fcb37074197a53798b777f7da',
        },
      },
    },
  },
  google: {
    keys: {
      maps: 'AIzaSyDUkOhuHgF_FMFUSOJA2yJez_UAq5I7s44',
    },
  },
  zapinho: {
    access_token: '624d0321ac87325780ef149d',
  },
  traccar: {
    rebox: {
      username: 'faleconosco@rebox.com.br',
      password: 'RBXSucesso0703$',
    },
  },
};
